import { useTrack } from "../lib/analytics";
import { appStoreLink } from "../lib/stores";

/**
 * The call to action at the end of an article.
 *
 * ── Why the copy is not the landing page's ───────────────────────────────────
 *
 * Someone who reached the bottom of an article did not arrive looking for an
 * app. They arrived with a question, and they read eight hundred words of the
 * answer. Repeating the home page's pitch at them treats that as if it never
 * happened. So this says the one sentence that follows from having read the
 * piece, and nothing else.
 *
 * ── Why `from` matters ───────────────────────────────────────────────────────
 *
 * It carries the article's slug into `web_store_click`, which is what turns the
 * blog from a thing we hope is working into a thing with a number next to it:
 * an article that is read and never converts is a different problem from one
 * nobody reads, and without this they look identical in the funnel.
 */
export function StoreCta({ from }: { from: string }) {
  const track = useTrack();
  return (
    <aside className="mt-14 rounded-[32px] border-[2.5px] border-ink bg-brand p-6 shadow-[5px_5px_0_0_var(--color-ink)] sm:p-8">
      <p className="font-display text-[clamp(1.3rem,3.5vw,1.7rem)] leading-tight font-bold text-onbrand text-balance">
        Pray to unlock your apps
      </p>
      <p className="mt-3 leading-relaxed text-onbrand">
        Bible Shield closes the apps that take your evenings at the times you
        choose, and opens them again after a short prayer written for the day
        you are actually having. Free to start.
      </p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <a
          href={appStoreLink(from)}
          onClick={() => track("web_store_click", { store: "appstore", from })}
          className="rim inline-flex h-[52px] items-center justify-center bg-surface px-6 font-display text-[16px] font-bold text-ink"
        >
          get it on the app store
        </a>
        {/* A status, not a button — there is no Play listing to link to yet.
            Outlined in the card's own white rather than in ink, because this
            one sits on the cobalt block. */}
        <span
          aria-disabled="true"
          className="inline-flex h-[52px] items-center justify-center rounded-pill border-[2.5px] border-dashed border-onbrand/70 px-6 font-display text-[16px] font-bold text-onbrand"
        >
          android — coming soon
        </span>
      </div>
    </aside>
  );
}
